import React, { useState } from 'react'
import { Popover } from '@material-ui/core'
import { Typography } from 'procyon-ui'

const ErrorDisplaySimplified = ({ hasError, error }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'account-error-popover' : undefined

  if (hasError) {
    return (
      <div>
        {/* Error Trigger: Soft Red Badge */}
        <button
          aria-describedby={id}
          onClick={handleClick}
          className='flex items-center justify-center w-[30px] h-[30px] bg-red-100 rounded hover:bg-red-200 transition-colors focus:outline-none text-red-600'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 20 20'
            fill='currentColor'
            className='w-5 h-5'
          >
            <path
              fillRule='evenodd'
              d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z'
              clipRule='evenodd'
            />
          </svg>
        </button>

        {/* Popover Content */}
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          <div className='p-2 max-w-[400px]'>
            <div className='border border-dashed border-gray-200 rounded p-2 bg-gray-50'>
              <Typography variant='body-regular' className='text-gray-700'>
                {error}
              </Typography>
            </div>
          </div>
        </Popover>
      </div>
    )
  }

  // Success State: Soft Green Badge (Matches your requested theme)
  return (
    <div className='flex items-center justify-center w-[30px] h-[30px] bg-green-100 rounded text-green-600 cursor-default'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 20 20'
        fill='currentColor'
        className='w-5 h-5'
      >
        <path
          fillRule='evenodd'
          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
          clipRule='evenodd'
        />
      </svg>
    </div>
  )
}

export default ErrorDisplaySimplified
